import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  confirmPopup: {
    width: '100%',
    maxWidth: 350,
  },
  actionGroup: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
    gap: '10px',
  },
}));

export default useStyles;
